"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonFunctions = void 0;
var LoginConfiguration_1 = require("../../../services/LoginConfiguration");
var UrlParameterHelper_1 = require("../../../services/UrlParameterHelper");
var CommonFunctions = /** @class */ (function () {
    function CommonFunctions() {
        this.tGuardMultiLoginStage = 'https://cgatemas.stage.att.com'
            + '/commonLogin/igate_wam/multiLogin.do';
        this.tGuardTokenServiceStage = 'https://cgate.stage.att.com/TokenService'
            + '/nxsATS/WATokenService?appID={appId}&returnURL={returnUrl}';
        this.tGuardMultiLoginProd = 'https://cprodmasx.att.com'
            + '/commonLogin/igate_wam/multiLogin.do';
        this.tGuardTokenServiceProd = 'https://cprodx.att.com/TokenService'
            + '/nxsATS/WATokenService?appID={appId}&returnURL={returnUrl}';
        this.forgotIDUrl = 'https://m.att.com/my/#/forgotLoginLanding'
            + '?origination_point=login&Flow_Indicator=FID';
        this.forgotPasswordUrl = 'https://m.att.com/my/#/forgotLoginLanding'
            + '?origination_point=login&Flow_Indicator=FPWD';
        this.haloCMechIdTest = LoginConfiguration_1.default.haloCIDPMechIdTest;
        this.haloCMechIdProd = LoginConfiguration_1.default.haloCIDPMechIdProd;
        this.haloCServicesMechIdTest = LoginConfiguration_1.default.haloCServicesMechIdTest;
        this.haloCServicesMechIdProd = LoginConfiguration_1.default.haloCServicesMechIdProd;
        this.haloCEndpointTest = LoginConfiguration_1.default.haloCAuthorizeEndpointTest;
        this.haloCEndpointProd = LoginConfiguration_1.default.haloCAuthorizeEndpointProd;
        this.haloCEndpointLogoutProdUrl = LoginConfiguration_1.default.haloCEndpointLogoutProdUrl;
        this.haloCEndpointLogoutTestUrl = LoginConfiguration_1.default.haloCEndpointLogoutTestUrl;
        this.urlParameterHelper = UrlParameterHelper_1.default.getInstance();
        this.appIdStage = LoginConfiguration_1.default.tgaurdAppIdStage;
        this.appIdProd = LoginConfiguration_1.default.tguardAppIdProd;
        this.inlineErrors = {
            attemptOneErrText: 'That sign-in info doesn’t look quite right.'
                + 'You may have more than one ID. Be sure to use the right ID and password combination.'
                + 'For help, select Forgot ID? or Forgot password? (LU100)',
            attemptThreeErrText: 'It seems you\'re having difficulty logging in to myAT&T.'
                + ' To protect your information, we lock accounts after too many unsuccessful sign-in tries,'
                + ' and you\'re getting close. Enter your user ID and password'
                + ' carefully on your next try.'
                + ' Select Forgot ID? or Forgot Password? below for further assistance.(LU200)',
            attemptTwoErrText: 'Hmm … That sign-in info isn’t working.'
                + ' You may have more than one ID. Be sure to use the right ID and password combination.'
                + ' For help, select Forgot ID? or Forgot password? (LU150)',
            capsLockWarningText: "Caps lock is on.  Be sure to turn it off.",
            fraudLockOneText: 'For your security, your AT&T Access ID has a temporary protection lock.'
                + ' To unlock it, use the Forgot Password link to reset your password. [FL001]',
            fraudLockTwoText: 'For your security, your AT&T Access ID has a temporary protection lock on it.'
                + ' To unlock it, call us at 877.285.0144. [FL002]',
            hardLockText: 'We want to keep your information safe. We temporarily locked'
                + ' your account after too many unsuccessful sign-in attempts. Choose'
                + ' Forgot User ID or Forgot password to unlock your ID. [LU003]',
            invalidEmailText: "Be sure to enter your email address in a valid format.",
            invalidPasswordText: "Be sure you enter a valid password.  If you don't remember your'\n                +'password, use the <b>Forgot password</b> link.",
            invalidUserIdText: "Be sure you enter a valid ID. If you don't remember your ID,"
                + " use the <b>Forgot ID</b> link.",
            softLockText: 'We want to keep your information safe. We temporarily locked your account after '
                + 'too many unsuccessful sign-in attempts. Choose Forgot User ID or Forgot password'
                + ' to unlock your ID. [LU002]',
            wirelessNumberText: "Wireless number? Enter 10 digits.",
        };
    }
    CommonFunctions.getInstance = function () {
        if (!CommonFunctions.instance) {
            CommonFunctions.instance = new CommonFunctions();
        }
        return CommonFunctions.instance;
    };
    CommonFunctions.prototype.invalidCredentailsCounter = function (result, errorMessageCounter, userID, returnUrl) {
        console.log('invalidCredentailsCounter: ', result.error);
        var errorMessage = '';
        if (result.error.errorId === 'MSLGNAUT006') {
            // let errMessageCounter = errorMessageCounter;
            //  errorMessageCounter++;
            // this.setState( { errorMessageCounter } );
            if (errorMessageCounter === 1) {
                // console.log( 'authenticateAndLogin result.error 1: ', result.error );
                errorMessage = this.inlineErrors.attemptOneErrText;
                // this.setState( { errorMessage: this.inlineErrors.attemptOneErrText } );
                return errorMessage;
            }
            else if (errorMessageCounter === 2) {
                // console.log( 'authenticateAndLogin result.error 2: ', result.error );
                errorMessage = this.inlineErrors.attemptTwoErrText;
                // this.setState( { errorMessage: this.inlineErrors.attemptTwoErrText } );
                return errorMessage;
            }
            else if (errorMessageCounter === 3 || errorMessageCounter === 4) {
                /*if (errorMessageCounter === 4
                    && (window.location.hostname.indexOf('m.att.com') !== -1
                        || window.location.hostname.indexOf('dssqa') !== -1 || true )) {
                        //  console.log( 'desktop flow' );
                            window.location.href = 'https://m.att.com/my/#/forgotLoginLanding?'
                                                    + 'origination_point=login&actionErrorCode=LGN_01_83'
                                                    + '&Flow_Indicator=FCOMB&olamRedirectInd=FullWeb'
                                                    + '&userIdFromLogin=' + userID
                                                    + '&Return_URL=' + returnUrl;
                } else {
                // console.log( 'authenticateAndLogin result.error 3: ', result.error );
                errorMessage = this.inlineErrors.attemptThreeErrText;
                // this.setState( { errorMessage: this.inlineErrors.attemptThreeErrText } );
                return errorMessage;
                }*/
                errorMessage = this.inlineErrors.attemptThreeErrText;
                return errorMessage;
            }
            else {
                errorMessage = this.inlineErrors.attemptThreeErrText;
                return errorMessage;
                // this.setState( { errorMessage: this.inlineErrors.attemptThreeErrText } );
            }
            // return errorMessage;
        }
        else if (result.error.errorId === 'MSLGNAUT004') {
            //  console.log( 'authenticateAndLogin MSLGNAUT004 ', result.error );
            errorMessage = this.inlineErrors.softLockText;
            // this.setState( { errorMessage: this.inlineErrors.softLockText } );
            return errorMessage;
        }
        else if (result.error.errorId === 'MSLGNAUT005') {
            //  console.log( 'authenticateAndLogin result.error 5: ', result.error );
            errorMessage = this.inlineErrors.hardLockText;
            // this.setState( { errorMessage: this.inlineErrors.hardLockText } );
            return errorMessage;
        }
        else if (result.error.errorId === 'MSLGNAUT019') {
            errorMessage = this.inlineErrors.fraudLockOneText;
            return errorMessage;
        }
        else if (result.error.errorId === 'MSLGNAUT020') {
            errorMessage = this.inlineErrors.fraudLockTwoText;
            return errorMessage;
        }
        else {
            //  console.log( 'authenticateAndLogin else scenario ');
            errorMessage = result.error.message;
            // this.setState( { errorMessage: result.error.message } );
            return errorMessage;
        }
    };
    CommonFunctions.prototype.blankCheck = function (parameter) {
        return (parameter === '' || parameter === null || parameter === undefined);
    };
    CommonFunctions.prototype.notBlankCheck = function (parameter) {
        if (parameter !== '' && parameter != null
            && parameter !== undefined) {
            return true;
        }
        else {
            return false;
        }
    };
    CommonFunctions.prototype.gotoRedirect = function (url) {
        document.location.href = url;
    };
    /*
    getReturnUrl(returnUrl: string): string {
        if ( returnUrl ) {
            return returnUrl;
        } else {
            const url = document.location.href +
                ( document.location.href.indexOf( '?' ) === -1 ? '?' : '&' ) +
                'authenticated=true';
            return url;
        // return 'https://www.att.com/shop/unified/authentication.html';
        }
    }*/
    CommonFunctions.prototype.createFormElement = function (name, value) {
        var ele = document.createElement('input');
        ele.setAttribute('type', 'hidden');
        ele.setAttribute('name', name);
        ele.setAttribute('value', value);
        return ele;
    };
    CommonFunctions.prototype.invokeTguard = function (userID, passwordValue, saveId, savedUserIdHandler, loginUrl, returnUrl) {
        var multiLoginUrl = this.getTGuardMultiLoginUrlForEnv();
        var tokenServiceUrl = this.getTGuardTokenServiceUrlForEnv();
        var appId = this.getTGuardAppIdForEnv();
        var form = document.createElement('form');
        form.setAttribute('method', 'POST');
        form.setAttribute('action', multiLoginUrl);
        form.appendChild(this.createFormElement('userid', userID));
        form.appendChild(this.createFormElement('password', passwordValue));
        form.appendChild(this.createFormElement('lang', 'en'));
        form.appendChild(this.createFormElement('persist', 'y'));
        if (savedUserIdHandler.sendToApi && saveId) {
            form.appendChild(this.createFormElement('remember_me', 'y'));
        }
        form.appendChild(this.createFormElement('loginURL', loginUrl));
        form.appendChild(this.createFormElement('cancelURL', loginUrl));
        var targetUrl = tokenServiceUrl;
        targetUrl = targetUrl.replace('{appId}', appId);
        targetUrl = targetUrl.replace('{returnUrl}', returnUrl);
        form.appendChild(this.createFormElement('targetURL', targetUrl));
        form.appendChild(this.createFormElement('urlParameters', 'loginComponent=true'));
        // Submit and delete the form
        document.body.appendChild(form);
        form.submit();
        form.parentNode.removeChild(form);
    };
    CommonFunctions.prototype.getTGuardMultiLoginUrlForEnv = function () {
        var url = document.location.href;
        if (this.isTestEnv()) {
            return this.tGuardMultiLoginStage;
        }
        else {
            return this.tGuardMultiLoginProd;
        }
    };
    CommonFunctions.prototype.getTGuardTokenServiceUrlForEnv = function () {
        var url = document.location.href;
        if (this.isTestEnv()) {
            return this.tGuardTokenServiceStage;
        }
        else {
            return this.tGuardTokenServiceProd;
        }
    };
    CommonFunctions.prototype.getTGuardAppIdForEnv = function () {
        var url = document.location.href;
        if (this.isTestEnv()) {
            return this.appIdStage;
        }
        else {
            return this.appIdProd;
        }
    };
    CommonFunctions.prototype.removeSlidDomain = function (slid) {
        if (this.notBlankCheck(slid) && slid.indexOf('slid.dum') > -1) {
            return slid.replace('@slid.dum', '');
        }
        else {
            return slid;
        }
    };
    CommonFunctions.prototype.getHaloCUrlForEnv = function () {
        var url = document.location.href;
        if (this.isTestEnv()) {
            return this.haloCEndpointTest;
        }
        else {
            return this.haloCEndpointProd;
        }
    };
    CommonFunctions.prototype.getHalocAppIdForEnv = function () {
        var url = document.location.href;
        if (this.isTestEnv()) {
            return this.haloCMechIdTest;
        }
        else {
            return this.haloCMechIdProd;
        }
    };
    CommonFunctions.prototype.getHaloCLogoutUrlForEnv = function () {
        var url = document.location.href;
        if (this.isTestEnv()) {
            return this.haloCEndpointLogoutTestUrl;
        }
        else {
            return this.haloCEndpointLogoutProdUrl;
        }
    };
    CommonFunctions.prototype.createHalocUrl = function (isPassive, haloClientId, returnUrl) {
        if (haloClientId === void 0) { haloClientId = null; }
        if (returnUrl === void 0) { returnUrl = null; }
        var finalUrl = '';
        var appId = haloClientId !== null ? haloClientId : this.getHalocAppIdForEnv();
        var port = window.location.port ? ':' + window.location.port : '';
        var host = window.location.hostname + port;
        var doLoginUrl = window.location.protocol + '//' + host + '/msapi/login/unauth/service/v1/haloc/do/login';
        if (this.notBlankCheck(sessionStorage.getItem('servicesReturnUrl'))) {
            var servicesReturnUrl = sessionStorage.getItem('servicesReturnUrl');
            finalUrl = servicesReturnUrl;
        }
        else if (this.notBlankCheck(returnUrl)) {
            finalUrl = returnUrl;
        }
        else {
            finalUrl = window.location.href;
        }
        finalUrl = this.cleanUrlParameters(finalUrl, ['lt', 'haloSuccess', 'postAuthError', 'authNState']);
        if (finalUrl.indexOf('?') === -1) {
            finalUrl = finalUrl + '?authNState=Y';
        }
        else {
            finalUrl = finalUrl + '';
        }
        finalUrl = encodeURIComponent(finalUrl);
        var state = encodeURIComponent('from=idp');
        var gotoUrl = doLoginUrl + "?host=" + host + "&state=" + state + "&client_id=" + appId + "&is_passive=" + isPassive + "&final_url=" + finalUrl;
        return gotoUrl;
    };
    CommonFunctions.prototype.cleanUrlParameters = function (url, parameters) {
        var idx = url.indexOf('?');
        if (idx >= 0) {
            var search = url.substring(idx + 1);
            var uparams = new UrlParameterHelper_1.default(search);
            for (var _i = 0, parameters_1 = parameters; _i < parameters_1.length; _i++) {
                var p = parameters_1[_i];
                uparams.delete(p);
            }
            var newsearch = uparams.toString();
            if (newsearch !== '') {
                newsearch = '?' + newsearch;
            }
            url = url.substring(0, idx) + newsearch;
        }
        return url;
    };
    CommonFunctions.prototype.createTguardTokenUrl = function (returnUrl) {
        var tokenServiceUrl = this.getTGuardTokenServiceUrlForEnv();
        var appId = this.getTGuardAppIdForEnv();
        var url = tokenServiceUrl;
        url = url.replace('{appId}', appId);
        url = url.replace('{returnUrl}', encodeURIComponent(returnUrl));
        return url;
    };
    CommonFunctions.prototype.isTestEnv = function (hostname) {
        var url = hostname !== null && hostname !== void 0 ? hostname : document.location.hostname;
        var isTestEnv = false;
        LoginConfiguration_1.default.testEnvironmentHostNameRegExps.forEach(function (re) {
            if (url.match(re)) {
                isTestEnv = true;
            }
        });
        console.log('isTestEnv env', hostname, isTestEnv);
        return isTestEnv;
    };
    CommonFunctions.prototype.generateNonce = function (length) {
        var result = '';
        var characters = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        // console.log('generateNonce ', result);
        return result;
    };
    CommonFunctions.prototype.doLoginUrl = function (isPassive, haloClientId, returnUrl) {
        if (haloClientId === void 0) { haloClientId = null; }
        if (returnUrl === void 0) { returnUrl = null; }
        // Don: At this point i don't think there is a notable difference
        // between this function and the createHalocUrl - so just calling
        // through and keeping this around incase there are external callers.
        return this.createHalocUrl(isPassive, haloClientId, returnUrl);
    };
    // tslint:disable-next-line:no-any
    CommonFunctions.prototype.getQueryParam = function (input) {
        console.log('UtilityServices:: getQueryParam(): input - ' + input);
        return this.urlParameterHelper.get(input);
    };
    CommonFunctions.prototype.getTargetUrl = function () {
        var _a;
        var url = this.getQueryParam('target_url');
        if (this.notBlankCheck(url)) {
            var whitelistRegexps = (_a = LoginConfiguration_1.default.urlWhitelistRegexp) !== null && _a !== void 0 ? _a : [];
            for (var _i = 0, whitelistRegexps_1 = whitelistRegexps; _i < whitelistRegexps_1.length; _i++) {
                var re = whitelistRegexps_1[_i];
                var pattern = new RegExp(re);
                if (pattern.test(url)) {
                    return url;
                }
            }
        }
        console.log('login-ui :: logoutComponent :: target_url not valid (encoded)', encodeURIComponent(url));
        return '';
    };
    CommonFunctions.redirectUrl = 'https://www.att.com/shop/unified/authentication.html';
    CommonFunctions.successEventName = 'loginSuccessEvent';
    CommonFunctions.extraSecurityFlag = false;
    return CommonFunctions;
}());
exports.CommonFunctions = CommonFunctions;
//# sourceMappingURL=CommonFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/CommonFunctions/CommonFunctions.js
// module id = 67
// module chunks = 8